import React from 'react'
import { Divider } from '../Controls';
import PageActions from './PageActions';
import texts from '../../assets/strings/privacy.js';
import Img from '../../assets/images/snowball.svg';

import './styles.less';

const PrivacyPage = () => 
    <div className="text-page privacy">
        <img className="title-image" src={Img} />
        <h1>{texts.title}</h1>
        <Divider />
        <div className="page-content" dangerouslySetInnerHTML={{__html: texts.html}}></div>
        <Divider />
        <PageActions />
    </div>

export default PrivacyPage;


// WEBPACK FOOTER //
// ./components/Pages/Privacy.js